/**
 * AUTO-GENERATED by agent-contracts-runtime. DO NOT EDIT.
 *
 * Regenerate via: npx agent-runtime generate
 */

export const resolvedDsl: Record<string, unknown> = {
  "version": 1,
  "system": {
    "id": "litedbmodel-gen",
    "name": "litedbmodel-gen Agent System",
    "default_workflow_order": [
      "audit-workflow",
      "implement-workflow"
    ]
  },
  "agents": {
    "litedbmodel-auditor": {
      "role_name": "litedbmodel Audit Analyst",
      "purpose": "Audits TypeScript source code that uses the litedbmodel ORM to detect common anti-patterns that cause data-integrity problems, performance degradation, or correctness bugs. Reads project files using file tools to find all litedbmodel usage sites.\nThe eight canonical anti-patterns to detect:\n  (1) LOOP_CREATE — Model.create() inside a loop; use createMany instead.\n  (2) DELETE_REINSERT — full delete then re-insert; use upsert instead.\n  (3) MISSING_IDEMPOTENCY — bare create() that throws on duplicate rows.\n  (4) AGGREGATE_SKIP — inserting un-aggregated data that needs group-by first.\n  (5) OVER_DELETE — delete with overly broad conditions.\n  (6) MISSING_LOCK — concurrent-write path without forUpdate: true.\n  (7) UNIQUE_MISSING — onConflict used without a DB UNIQUE constraint.\n  (8) N_PLUS_ONE — find/findOne called inside a loop.\n\nlitedbmodel API reference (for remediation guidance):\n  Model.create(cols, opts?) — opts: { returning, onConflict, onConflictIgnore, onConflictUpdate }\n  Model.createMany(rows, opts?) — batch INSERT with same opts.\n  Model.find(conds, opts?) — opts: { order, limit, offset, forUpdate }\n  Model.findOne(conds, opts?) — single-row SELECT.\n  Model.findById(pkeyResult) — find by PkeyResult object.\n  Model.update(conds, vals, opts?) — UPDATE matching rows.\n  Model.updateMany(rows, opts?) — bulk UPDATE; opts: { keyColumns }\n  Model.delete(conds, opts?) — DELETE matching rows.\n  DBModel.transaction(fn, opts?) — opts: { retryOnError, retryLimit }\n  SKIP — exclude a condition or column dynamically.\n  sql tagged template — operator-based conditions.\n  forUpdate: true — SELECT FOR UPDATE (must be inside a transaction).\n  onConflict + onConflictUpdate — upsert (target column must have UNIQUE/PK).\n  onConflict + onConflictIgnore — insert-or-ignore.\n\nProduces structured findings (AgentAuditResult shape) with severity, category, location, message, and actionable remediation referencing the correct litedbmodel API.",
      "mode": "read-only",
      "can_read_artifacts": [],
      "can_write_artifacts": [],
      "can_invoke_agents": [],
      "can_execute_tools": [],
      "can_return_handoffs": [
        "litedbmodel-audit-result"
      ],
      "responsibilities": [
        "Read project source files using file tools to find all litedbmodel model import sites and usage.",
        "Classify each usage occurrence against the eight anti-pattern categories.",
        "Assign severity — info/warning/error/critical — based on data-integrity and performance impact.",
        "Provide specific remediation guidance referencing the correct litedbmodel API.",
        "Compute an overall riskLevel reflecting the most severe finding.",
        "Return a findings array even when it is empty (no issues found)."
      ],
      "constraints": [
        "Do not suggest API methods that are not part of the documented litedbmodel interface.",
        "Do not mutate, write, or propose direct file changes; only produce findings.",
        "Stop and escalate if the source exceeds 200 KB or contains no litedbmodel import statements."
      ],
      "rules": [
        {
          "id": "R-AUDIT-001",
          "description": "Always recommend Model.createMany() as the replacement for any loop body that contains a Model.create() call.",
          "severity": "mandatory"
        },
        {
          "id": "R-AUDIT-002",
          "description": "When a delete-then-reinsert pattern is detected, recommend Model.createMany() with onConflict + onConflictUpdate as the idiomatic upsert replacement.",
          "severity": "mandatory"
        },
        {
          "id": "R-AUDIT-003",
          "description": "Whenever onConflict / onConflictUpdate is recommended, note that the target column(s) must carry a UNIQUE or PRIMARY KEY constraint in the database schema.",
          "severity": "mandatory"
        },
        {
          "id": "R-AUDIT-004",
          "description": "N+1 findings must include the batch alternative: find() with an IN-equivalent condition, createMany(), or updateMany().",
          "severity": "mandatory"
        },
        {
          "id": "R-AUDIT-005",
          "description": "Race-condition findings in concurrent-write paths must recommend findOne/find with forUpdate: true inside DBModel.transaction().",
          "severity": "mandatory"
        }
      ],
      "escalation_criteria": [
        {
          "condition": "The provided source code exceeds 200 KB in total size.",
          "action": "stop_and_report"
        },
        {
          "condition": "The provided source code contains no litedbmodel import statements and cannot be meaningfully audited.",
          "action": "stop_and_report"
        }
      ]
    },
    "litedbmodel-implementer": {
      "role_name": "litedbmodel Implementation Engineer",
      "purpose": "Implements litedbmodel DBModel-based business logic directly in the user's project by reading model definitions and SQL schema from the filesystem, then writing TypeScript source files. Proactively applies all litedbmodel best-practice patterns from the start: Model.createMany() for batch inserts, onConflict+onConflictUpdate for idempotent upserts, forUpdate: true for concurrent-safe reads, and DBModel.transaction() for multi-step operations. Never produces code that contains any of the eight canonical anti-patterns.\nlitedbmodel API reference (use ONLY these — never invent methods):\n  Model.create(cols, opts?) — single INSERT.\n    opts: { returning, onConflict, onConflictIgnore, onConflictUpdate }\n  Model.createMany(rows, opts?) — batch INSERT with same opts.\n  Model.find(conds, opts?) — SELECT.\n    opts: { order, limit, offset, forUpdate }\n  Model.findOne(conds, opts?) — single-row SELECT.\n  Model.findById(pkeyResult) — find by PkeyResult object.\n  Model.update(conds, vals, opts?) — UPDATE matching rows.\n  Model.updateMany(rows, opts?) — bulk UPDATE.\n    opts: { keyColumns }\n  Model.delete(conds, opts?) — DELETE matching rows.\n  Model.query(sql, params) — raw SQL returning typed model instances.\n  DBModel.execute(sql) — raw SQL for DDL/maintenance (no model instances).\n  DBModel.transaction(fn, opts?) — transaction wrapper.\n    opts: { retryOnError, retryLimit }\n  SKIP — exclude a condition or column dynamically.\n  sql tagged template — operator-based conditions.\n    Column references: sql`${Model.col} > ${val}`\n    IS NULL: sql`${Model.col} IS NULL`\n    IN: [sql`${Model.col} IN (?)`, [...values]]\n  forUpdate: true — SELECT FOR UPDATE (must be inside a transaction).\n  onConflict + onConflictUpdate — upsert.\n    Target column(s) must have UNIQUE or PRIMARY KEY constraint.\n  onConflict + onConflictIgnore — insert-or-ignore.\n    Same constraint requirement.\n  Column references are symbol-based: Model.column_name (not strings).\n  Conditions are type-safe tuples: [[Model.col, value], ...].",
      "mode": "read-write",
      "can_read_artifacts": [],
      "can_write_artifacts": [],
      "can_invoke_agents": [],
      "can_execute_tools": [],
      "can_return_handoffs": [
        "litedbmodel-implement-result"
      ],
      "responsibilities": [
        "Step 1: Use Glob to find model definition files matching the models glob pattern in the user request. Read each matched file to extract model classes, column definitions, and table names.",
        "Step 2: Read the target file specified in the user request. Examine its current content. If it contains only stubs, TODOs, or empty class bodies, you MUST write the full implementation.",
        "Step 3: Use Edit or Write tool to add the implementation directly to the target file. You MUST actually modify the file on disk. Never claim 'implementation is already present' unless the function body you just read contains real business logic — not stubs or TODOs.",
        "Apply correct patterns proactively — never generate loop-inside-create, delete-reinsert, bare non-idempotent create, or N+1 patterns.",
        "Surface design concerns (missing UNIQUE constraints, missing transactions, ambiguous schema) as findings with severity info or warning."
      ],
      "constraints": [
        "Only reference model classes and columns that exist in the project's model definition files.",
        "Never invent or fabricate litedbmodel API methods not listed in the API reference above.",
        "Keep all generated TypeScript strict-mode compliant.",
        "If the model/schema context is insufficient, list the missing information explicitly and stop."
      ],
      "rules": [
        {
          "id": "R-IMPL-001",
          "description": "Never generate a for/while loop body that calls Model.create(). Always use Model.createMany() for batch writes.",
          "severity": "mandatory"
        },
        {
          "id": "R-IMPL-002",
          "description": "Idempotent single-row writes must pass onConflict with either onConflictIgnore: true or onConflictUpdate: [...] to Model.create(). Bare Model.create() that can throw on duplicate keys is forbidden.",
          "severity": "mandatory"
        },
        {
          "id": "R-IMPL-003",
          "description": "Multi-step read-modify-write sequences must be wrapped in DBModel.transaction() to prevent partial updates.",
          "severity": "mandatory"
        },
        {
          "id": "R-IMPL-004",
          "description": "Any read that is immediately followed by a conditional write in a concurrent context must use findOne/find with forUpdate: true inside a transaction.",
          "severity": "mandatory"
        },
        {
          "id": "R-IMPL-005",
          "description": "Whenever onConflict is generated, add a code comment noting that the referenced column(s) must have a UNIQUE or PRIMARY KEY constraint.",
          "severity": "mandatory"
        }
      ],
      "escalation_criteria": [
        {
          "condition": "The feature description is too ambiguous to be mapped to any model class in the project.",
          "action": "stop_and_report"
        },
        {
          "condition": "No model definitions or SQL schema found in the project and the feature requires specific column knowledge.",
          "action": "stop_and_report"
        }
      ]
    }
  },
  "tasks": {
    "audit-litedbmodel-usage": {
      "description": "Audit TypeScript source files that import or use litedbmodel model classes. Detect the eight canonical anti-patterns (LOOP_CREATE, DELETE_REINSERT, MISSING_IDEMPOTENCY, AGGREGATE_SKIP, OVER_DELETE, MISSING_LOCK, UNIQUE_MISSING, N_PLUS_ONE) and return structured findings with severity ratings and remediation guidance referencing the correct litedbmodel API.",
      "target_agent": "litedbmodel-auditor",
      "model_class": "standard",
      "allowed_from_agents": [
        "litedbmodel-auditor"
      ],
      "workflow": "audit-workflow",
      "input_artifacts": [],
      "invocation_handoff": "litedbmodel-audit-request",
      "result_handoff": "litedbmodel-audit-result",
      "responsibilities": [
        "Parse the provided source code for litedbmodel model import sites and all subsequent usages.",
        "Classify each usage occurrence against the eight anti-pattern categories.",
        "Return findings conforming to the litedbmodel-audit-result schema."
      ],
      "completion_criteria": [
        "All litedbmodel usage sites in the provided code have been inspected.",
        "The findings array is populated (may be empty when no issues are found).",
        "The riskLevel field reflects the highest-severity finding present.",
        "Each finding with severity >= warning includes a recommendation field referencing the correct litedbmodel API method."
      ]
    },
    "implement-litedbmodel-feature": {
      "description": "Implement a litedbmodel-based business feature by reading model definitions and writing TypeScript code directly to the target file. The agent uses file tools (Glob, Read, Edit, Write) to operate on the user's project, proactively avoiding all eight litedbmodel anti-patterns.",
      "target_agent": "litedbmodel-implementer",
      "model_class": "thinking",
      "allowed_from_agents": [
        "litedbmodel-implementer"
      ],
      "workflow": "implement-workflow",
      "input_artifacts": [],
      "invocation_handoff": "litedbmodel-implement-request",
      "result_handoff": "litedbmodel-implement-result",
      "responsibilities": [
        "Parse the feature description to identify the required data operations.",
        "Read model definition files using Glob + Read to understand available models, columns, and constraints.",
        "Read the target file to understand its current state.",
        "Write the implementation to the target file using Edit or Write tools.",
        "Apply best-practice patterns proactively (createMany, upsert, forUpdate, transaction) so that no anti-pattern appears in the written code.",
        "Report what was changed in the changedFiles array."
      ],
      "completion_criteria": [
        "The target file has been modified on disk via file tools.",
        "Written code uses only documented litedbmodel API methods.",
        "None of the eight anti-patterns appear in the written code.",
        "The changedFiles array lists every file that was created or updated.",
        "If schema context is insufficient, missing information is listed in the findings array and the agent stops."
      ]
    }
  },
  "handoff_types": {
    "litedbmodel-audit-request": {
      "version": 1,
      "description": "Invocation handoff carrying the audit context passed to the litedbmodel-auditor agent. The userRequest field contains the structured prompt built by the context-builder (target path header, source code, and per-pattern instructions).",
      "schema": {
        "type": "object",
        "required": [
          "userRequest"
        ],
        "properties": {
          "userRequest": {
            "type": "string",
            "description": "Full audit prompt including target path, source code, and anti-pattern inspection instructions. Capped at 16 KB."
          }
        }
      }
    },
    "litedbmodel-implement-request": {
      "version": 1,
      "description": "Invocation handoff carrying the implementation context passed to the litedbmodel-implementer agent. The userRequest field contains the structured prompt built by the context-builder (feature description, model glob, target file path, and instructions to use file tools).",
      "schema": {
        "type": "object",
        "required": [
          "userRequest"
        ],
        "properties": {
          "userRequest": {
            "type": "string",
            "description": "Full implementation prompt including feature description, model glob pattern, target file path, and instructions to read models and write implementation using file tools. Capped at 16 KB."
          }
        }
      }
    },
    "litedbmodel-audit-result": {
      "version": 1,
      "description": "Structured audit result returned by the litedbmodel-auditor agent. Conforms to the AgentAuditResult base shape defined in cli-contract.yaml#/components/schemas/AgentAuditResult. Findings use litedbmodel-specific category vocabulary: LOOP_CREATE, DELETE_REINSERT, MISSING_IDEMPOTENCY, AGGREGATE_SKIP, OVER_DELETE, MISSING_LOCK, UNIQUE_MISSING, N_PLUS_ONE.",
      "schema": {
        "type": "object",
        "required": [
          "summary",
          "riskLevel",
          "findings"
        ],
        "properties": {
          "summary": {
            "type": "string",
            "description": "One-paragraph summary of the audit result."
          },
          "riskLevel": {
            "type": "string",
            "enum": [
              "low",
              "medium",
              "high",
              "critical"
            ],
            "description": "Overall risk level reflecting the highest-severity finding."
          },
          "findings": {
            "type": "array",
            "items": {
              "type": "object",
              "required": [
                "severity",
                "category",
                "message"
              ],
              "properties": {
                "id": {
                  "type": "string"
                },
                "severity": {
                  "type": "string",
                  "enum": [
                    "info",
                    "warning",
                    "error",
                    "critical"
                  ]
                },
                "category": {
                  "type": "string",
                  "description": "One of: LOOP_CREATE | DELETE_REINSERT | MISSING_IDEMPOTENCY | AGGREGATE_SKIP | OVER_DELETE | MISSING_LOCK | UNIQUE_MISSING | N_PLUS_ONE"
                },
                "target": {
                  "type": "string",
                  "description": "Class name or function where the issue occurs."
                },
                "location": {
                  "type": "string",
                  "description": "File path and optional line number."
                },
                "message": {
                  "type": "string"
                },
                "recommendation": {
                  "type": "string",
                  "description": "Actionable fix referencing the correct litedbmodel API method."
                },
                "confidence": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "evidence": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "required": [
                      "type",
                      "content"
                    ],
                    "properties": {
                      "type": {
                        "type": "string"
                      },
                      "content": {
                        "type": "string"
                      },
                      "source": {
                        "type": "string"
                      }
                    }
                  }
                },
                "details": {
                  "type": "object",
                  "description": "Arbitrary additional structured detail."
                }
              }
            }
          },
          "recommendedActions": {
            "type": "array",
            "items": {
              "type": "object",
              "required": [
                "kind",
                "title"
              ],
              "properties": {
                "kind": {
                  "type": "string",
                  "enum": [
                    "run_command",
                    "edit_file",
                    "review",
                    "confirm",
                    "block",
                    "ignore"
                  ]
                },
                "title": {
                  "type": "string"
                },
                "command": {
                  "type": "string"
                },
                "target": {
                  "type": "string"
                },
                "rationale": {
                  "type": "string"
                }
              }
            }
          },
          "metadata": {
            "type": "object",
            "properties": {
              "tool": {
                "type": "string"
              },
              "command": {
                "type": "string"
              },
              "version": {
                "type": "string"
              },
              "generatedAt": {
                "type": "string"
              },
              "adapter": {
                "type": "string"
              },
              "model": {
                "type": "string"
              }
            }
          }
        }
      }
    },
    "litedbmodel-implement-result": {
      "version": 1,
      "description": "Structured implementation report returned by the litedbmodel-implementer agent after writing files directly. Extends the AgentAuditResult base shape with changedFiles (what was created/modified) and optional dependency/note fields. Findings contain design observations (e.g. UNIQUE_MISSING, missing transaction wrapper).",
      "schema": {
        "type": "object",
        "required": [
          "summary",
          "riskLevel",
          "findings",
          "changedFiles"
        ],
        "properties": {
          "summary": {
            "type": "string",
            "description": "One-paragraph summary of what was implemented."
          },
          "riskLevel": {
            "type": "string",
            "enum": [
              "low",
              "medium",
              "high",
              "critical"
            ],
            "description": "Overall risk level of the implementation."
          },
          "findings": {
            "type": "array",
            "description": "Design observations and caveats about the implementation.",
            "items": {
              "type": "object",
              "required": [
                "severity",
                "category",
                "message"
              ],
              "properties": {
                "id": {
                  "type": "string"
                },
                "severity": {
                  "type": "string",
                  "enum": [
                    "info",
                    "warning",
                    "error",
                    "critical"
                  ]
                },
                "category": {
                  "type": "string"
                },
                "target": {
                  "type": "string"
                },
                "location": {
                  "type": "string"
                },
                "message": {
                  "type": "string"
                },
                "recommendation": {
                  "type": "string"
                },
                "confidence": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "evidence": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "required": [
                      "type",
                      "content"
                    ],
                    "properties": {
                      "type": {
                        "type": "string"
                      },
                      "content": {
                        "type": "string"
                      },
                      "source": {
                        "type": "string"
                      }
                    }
                  }
                },
                "details": {
                  "type": "object",
                  "description": "Arbitrary additional structured detail."
                }
              }
            }
          },
          "recommendedActions": {
            "type": "array",
            "items": {
              "type": "object",
              "required": [
                "kind",
                "title"
              ],
              "properties": {
                "kind": {
                  "type": "string",
                  "enum": [
                    "run_command",
                    "edit_file",
                    "review",
                    "confirm",
                    "block",
                    "ignore"
                  ]
                },
                "title": {
                  "type": "string"
                },
                "command": {
                  "type": "string"
                },
                "target": {
                  "type": "string"
                },
                "rationale": {
                  "type": "string"
                }
              }
            }
          },
          "changedFiles": {
            "type": "array",
            "description": "Files that the agent created or modified directly.",
            "items": {
              "type": "object",
              "required": [
                "path",
                "action"
              ],
              "properties": {
                "path": {
                  "type": "string",
                  "description": "Relative path of the created/modified file."
                },
                "action": {
                  "type": "string",
                  "enum": [
                    "created",
                    "updated"
                  ]
                },
                "rationale": {
                  "type": "string"
                }
              }
            }
          },
          "dependencies": {
            "type": "array",
            "description": "npm packages required but not yet in the project.",
            "items": {
              "type": "string"
            }
          },
          "notes": {
            "type": "string",
            "description": "Additional integration instructions."
          },
          "metadata": {
            "type": "object",
            "properties": {
              "tool": {
                "type": "string"
              },
              "command": {
                "type": "string"
              },
              "version": {
                "type": "string"
              },
              "generatedAt": {
                "type": "string"
              },
              "adapter": {
                "type": "string"
              },
              "model": {
                "type": "string"
              }
            }
          }
        }
      }
    }
  },
  "guardrails": {
    "output-schema-conformance": {
      "description": "All agent outputs must conform to the declared result handoff schema before being returned to the CLI formatter. Non-conformant output breaks exit-code mapping and structured reporting.",
      "scope": {
        "agents": [
          "litedbmodel-auditor",
          "litedbmodel-implementer"
        ],
        "tasks": [
          "audit-litedbmodel-usage",
          "implement-litedbmodel-feature"
        ]
      },
      "rationale": "Structured output (AgentAuditResult shape) is a hard contract for downstream CLI consumers. Validation must happen before the result reaches the formatter so that exit codes remain reliable."
    }
  },
  "guardrail_policies": {
    "litedbmodel-safety-policy": {
      "rules": [
        {
          "guardrail": "output-schema-conformance",
          "severity": "critical",
          "action": "block"
        }
      ]
    }
  },
  "workflows": {
    "audit-workflow": {
      "description": "Single-agent workflow that audits TypeScript source files for litedbmodel ORM anti-patterns and returns structured findings.",
      "trigger": "cli-command",
      "entry_conditions": [
        "User provides a TypeScript file or directory path to audit.",
        "Source code contains at least one litedbmodel model import."
      ],
      "steps": [
        {
          "type": "delegate",
          "task": "audit-litedbmodel-usage",
          "from_agent": "litedbmodel-auditor"
        }
      ]
    },
    "implement-workflow": {
      "description": "Single-agent workflow that generates TypeScript implementation code for a litedbmodel-based feature described by the user.",
      "trigger": "cli-command",
      "entry_conditions": [
        "User provides a natural-language feature description.",
        "At least model definitions or SQL schema context is available."
      ],
      "steps": [
        {
          "type": "delegate",
          "task": "implement-litedbmodel-feature",
          "from_agent": "litedbmodel-implementer"
        }
      ]
    }
  }
} as const;
